import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { Button } from "../../button/Button";
export const StyledFooter = styled.div `
  flex-grow: 1;
  margin-right: 16px;
  margin-top: -8px;
  margin-bottom: 16px;
  align-items: center;
  justify-content: flex-end;
  display: flex;
`;
export const CalendarFooter = ({ children, onClose, stringMap }) => (_jsxs(StyledFooter, { "data-testid": "DateCalendarFooter", children: [children, _jsx(Button, { onClick: onClose, size: "small", priority: "tertiary", children: stringMap.closeCalendar })] }));
